module.exports = __webpack_public_path__ + "img/20_54.1b0f26eb.png";